const {_setDefaults} = require( 'gsap/gsap-core' );

/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.navbar-toggle' ).on( 'toggleAfter', ( event ) => {
        $( '.primary-nav' ).slideToggle();
      } );

      if ( $( '.form-skin .ll-file-upload' ).length > 0 && typeof( gform ) !== 'undefined' ) {
        $( 'input[type=\'file\']' ).change( function() {
          const fullPath = $( this ).val();
          let filename = fullPath.replace( /^.*[\\/]/, '' );
          if ( filename === '' ) {
            filename = 'No file chosen';
          }
          const theInput = $( this ).parent().find( '.ll-file-upload span' );
          $( theInput ).text( filename );
        } );
      }
      // hide any filter titles if they aint got nuthin
      if ( document.querySelector( '.searchandfilter' ) ) {
        // query all the ul elements within our filters
        const filters = document.querySelectorAll(
            '.searchandfilter > ul > li > ul',
        );

        // hide the parent (li) element for any that are empty
        filters.forEach( ( filter ) => {
          if ( filter.children.length === 0 ) {
            filter.parentElement.style.display = 'none';
          }
        } );

        $( 'form.searchandfilter ul > li > h4' ).on( 'click', function() {
          $( this ).toggleClass( 'is-active' );
        } );

        const pathname = $( location ).attr( 'href' );
        if ( pathname.includes( 'brand' ) ) {
          $( '.sf-field-taxonomy-ll_brand h4' ).addClass( 'is-active' );
        }
        if ( pathname.includes( 'color' ) ) {
          $( '.sf-field-taxonomy-pa_color-finish > h4' ).addClass( 'is-active' );
        }
        if ( pathname.includes( 'product_cat' ) ) {
          $( '.sf-field-taxonomy-product_cat > h4' ).addClass( 'is-active' );
        }
      }

      $( '.current-filters .search-pill.brand' ).on( 'click', function() {
        // $value = $( this ).data( 'search-value' );
        $( '.sf-field-taxonomy-ll_brand .sf-level-0.sf-item-0 label' ).click();
      } );

      // do all the search and filter stuff again but wrap it so it loads after filter
      $( document ).on( 'sf:ajaxfinish', '.searchandfilter', function() {
        $( '.current-filters .search-pill' ).on( 'click', function() {
          $value = $( this ).data( 'search-value' );
          $( 'input[value=\''+$value+'\']' ).click();
        } );

        $( '.current-filters .search-pill.brand' ).on( 'click', function() {
          // $value = $( this ).data( 'search-value' );
          $( '.sf-field-taxonomy-ll_brand .sf-level-0.sf-item-0 label' ).click();
        } );

        // query all the ul elements within our filters
        const filters = document.querySelectorAll(
            '.searchandfilter > ul > li > ul',
        );

        // hide the parent (li) element for any that are empty
        filters.forEach( ( filter ) => {
          if ( filter.children.length === 0 ) {
            filter.parentElement.style.display = 'none';
          }
        } );
        $( 'form.searchandfilter ul > li > h4' ).on( 'click', function() {
          $( this ).toggleClass( 'is-active' );
        } );
        const pathname = $( location ).attr( 'href' );
        if ( pathname.includes( 'brand' ) ) {
          $( '.sf-field-taxonomy-ll_brand h4' ).addClass( 'is-active' );
        }
        if ( pathname.includes( 'color' ) ) {
          $( '.sf-field-taxonomy-pa_color-finish > h4' ).addClass( 'is-active' );
        }
        if ( pathname.includes( 'product_cat' ) ) {
          $( '.sf-field-taxonomy-product_cat > h4' ).addClass( 'is-active' );
        }
      } );

      $( '.js-init-video' ).magnificPopup( {
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
        callbacks: {
          open: function() {
            $( 'video' ).trigger( 'pause' );
          },
          close: function() {
            $( 'video' ).trigger( 'play' );
          },
        },
      } );

      // IF SELECTOR HAS DEFAULT SET SWATCHES AND TEXT ACCORDINGLY ON LOAD
      if ( $( 'select#pa_color-finish' ).val( ) != null ) {
        $( '.color-swatches' ).each( function() {
          if ( $( this ).data( 'color-slug' ) === $( 'select#pa_color-finish' ).val() ) {
            $( this ).addClass( 'selected' );
            const colorName = ( $( this ).data( 'color-name' ) );
            $( '#selected-swatch' ).text( colorName );
          }
        } );
      }

      // WHEN SWATCHES ARE CLICKED, CHANGE THE DROPDOWN SELECTION AND NAME OF COLOR
      $( '.color-swatches' ).on( 'click', function() {
        // var form = event.data.variationForm;
        const colorSlug = ( $( this ).data( 'color-slug' ) );
        const colorName = ( $( this ).data( 'color-name' ) );
        $( '#selected-swatch' ).text( colorName );
        $( 'select#pa_color-finish' ).val( colorSlug );
        $( 'select#pa_color-finish' ).trigger( 'change' );
        // $( 'form.variations_form' ).trigger( 'woocommerce_variation_has_changed' );

        console.log( $( 'form.variations_form' ) );
        $( '.color-swatches' ).each( function() {
          if ( $( this ).data( 'color-slug' ) === $( 'select#pa_color-finish' ).val() ) {
            $( this ).addClass( 'selected' );
          } else {
            $( this ).removeClass( 'selected' );
          }
        } );
      } );
      // HEADER SEARCH BUTTON
      $( '.search-button' ).on( 'click', function() {
        $( 'html' ).addClass( 'searchActivated no-scroll' );
        $( 'input.hhi-search' ).focus();
      } );
      $( '.search-popup__icon-wrapper' ).on( 'click', function() {
        $( 'html' ).removeClass( 'searchActivated no-scroll' );
      } );
      // WHEN SELECTOR CHANGES, CHANGE THE SWATCH
      $( '.woocommerce select#pa_color-finish' ).on( 'change', function() {
        const selectedVal = $( this ).val();
        $( '.color-swatches' ).each( function() {
          if ( $( this ).data( 'color-slug' ) === selectedVal ) {
            $( this ).addClass( 'selected' );
            const colorName = ( $( this ).data( 'color-name' ) );
            $( '#selected-swatch' ).text( colorName );
          } else {
            $( this ).removeClass( 'selected' );
          }
        } );
      } );

      // IF THEY CLICK THE WOO CLEAR BUTTON
      $( '.woocommerce .reset_variations' ).on( 'click', function() {
        $( '.color-swatches' ).each( function() {
          $( this ).removeClass( 'selected' );
        } );
      } );

      $( '.current-filters .search-pill' ).on( 'click', function() {
        $value = $( this ).data( 'search-value' );
        $( 'input[value=\''+$value+'\']' ).click();
      } );

      const updateBannerHeight = () => {
        if ( $( '.nav__cta-banner' ).length > 0 ) {
          const ctaBannerHeight = $( '.nav__cta-banner' ).outerHeight();
          console.log( ctaBannerHeight ); // Verify the value
          document.documentElement.style.setProperty( '--ctaBannerHeight', `${ctaBannerHeight}px` );
        }
      };

      function handleMobileChange( event ) {
        /*
         * Remove any inline display values when the screen changes
         * between mobile and desktop state. This allows the default
         * stylings to kick in and prevent any weird "half mobile half desktop"
         * nav display states that sometimes occur while resizing the browser
         * Also remove any active is-open classes from the toggle and nav to reset
         * its state when switching between screen sizes
         */
        updateBannerHeight();
        if ( event.matches ) {
          if ( $( '.primary-nav' ).length > 0 ) {
            $( '.primary-nav' ).get( 0 ).style.removeProperty( 'display' );

            $( '.navbar-toggle, .primary-nav' ).removeClass( 'is-open' );
          }
        }
      }

      /* Run the handleMobileChange function when the screen sizes changes based on the mobileSize const */
      const mobileSize = window.matchMedia( '(min-width: 768px)' );
      handleMobileChange( mobileSize );
      mobileSize.addEventListener( 'change', handleMobileChange );

      /* Allow selects to have placeholder styles */
      checkSelectPlaceholder();
      $( '.gfield_select' ).on( 'change', function() {
        checkSelectPlaceholder();
      } );
      function checkSelectPlaceholder() {
        if ( $( '.gfield_select' ).find( 'option:selected' ).hasClass( 'gf_placeholder' ) ) {
          $( '.gfield_select' ).addClass( 'placeholder-selected' );
        } else {
          $( '.gfield_select' ).removeClass( 'placeholder-selected' );
        }
      }
      // ANNOUNCEMENT BANNER STUFFS
      window.debounce = require( 'lodash/debounce' );

      function closeAnnouncementBanner() {
        $( '#announcement-banner' ).slideUp( 0, function() {
          $( ':root' ).css( '--announcementBannerHeight', `0px` );
        } );
      }
      function openAnnouncementBanner() {
        $( '#announcement-banner' ).slideDown( 0, function() {
          const bannerHeight = $( '#announcement-banner' ).outerHeight();
          $( ':root' ).css( '--announcementBannerHeight', `${bannerHeight}px` );
        } );
        announcementBannerHeight();
      }
      function announcementBannerHeight() {
        if ( $( '#announcement-banner:visible' ).length ) {
          const bannerHeight = $( '#announcement-banner' ).outerHeight();
          $( ':root' ).css( '--announcementBannerHeight', `${bannerHeight}px` );
        }
      }

      announcementBannerHeight();
      $( window ).on( 'resize', debounce( function() {
        announcementBannerHeight();
      }, 100 ) );

      if ( !sessionStorage.getItem( 'll-announcement-banner-seen' ) ) {
        sessionStorage.setItem( 'll-announcement-banner-seen', 'false' );
      }
      if ( sessionStorage.getItem( 'll-announcement-banner-seen' ) === 'false' ) {
        openAnnouncementBanner();
      }

      $( '#announcement-banner_close' ).on( 'click', function() {
        closeAnnouncementBanner();
        sessionStorage.setItem( 'll-announcement-banner-seen', 'true' );
      } );

      $( '.navbar-toggle' ).on( 'click', function() {
        const $navbarIsOpen = $( this ).hasClass( 'is-open' );
        const $primaryIsOpen = $( '.primary-navs' ).hasClass( 'is-open' );
        const $primaryNavs = $( '.primary-navs' );
        if ( $primaryIsOpen && !$navbarIsOpen ) {
          console.log( $primaryNavs );
          $primaryNavs.find( '.nav-state' ).trigger( 'click' );
        }
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'common', COMPONENT );
} )( app );
